import { useState } from "react";
function useFlashInputVisibilityToggle(fieldType = "text") {
  const [isPasswordField, setIsPasswordField] = useState(!0);
  function toggleVisibility() {
    setIsPasswordField((prev) => !prev);
  }
  return {
    type: isPasswordField ? "password" : fieldType,
    toggleVisibility
  };
}
export {
  useFlashInputVisibilityToggle
};
//# sourceMappingURL=useFlashInputVisibilityToggle.js.map
